<template lang="pug">
.list-of-components
    .flex.flex-wrap.-m-5
        .mb-4.p-5(class="w-1/2")
            .block.mb-4
                h1 Title
                h2 Heading
                h3 SubHeading

            .block.mb-4
                strong
                    | Label
                p
                    | Lorem ipsum dolor sit amet, consectetur adipisicing

            .block.mb-4
                strong
                    | Label
                p
                    | Carrot cake wafer brownie macaroon. Cheesecake sweet jelly cookie liquorice wafer powder oat cake danish. Sweet chupa chups cookie croissant. Cookie chupa chups jelly-o dessert powder jelly beans icing.

            .mb-4
                .flex.items-center.justify-between.my-2.py-3.border-b
                    span
                        | Label
                    Strong
                        | Info
                .flex.items-center.justify-between.my-2.py-3.border-b
                    span
                        | Label
                    Strong
                        | Info
                .flex.items-center.justify-between.mt-2.pt-3
                    span
                        | Label
                    Strong
                        | Info

        .mb-4.p-5(class="w-1/2")
            ul.lists.list-disc
                li Lorem ipsum dolor sit amet, consectetur  
                li Lorem ipsum consectetur adipisicing elit
                li Lorem ipsum dolor sit amet, consectetur adipisicing 
                li Lorem ipsum dolor consectetur
                li Lorem ipsum dolor sit amet, consectetur adipisicing

            ol.lists.list-decimal
                li Lorem ipsum dolor consectetur
                li Lorem ipsum dolor consectetur adipisicing elit
                li Lorem ipsum dolor sit amet, consectetur  

            ul.lists
                li Lorem ipsum dolor sit amet, consectetur 
                li Lorem ipsum dolor  consectetur adipisicing elit
                li Lorem ipsum dolor sit amet, consectetur adipisicing

</template>

<script>
export default {
    name: 'lists'
}
</script>

<style lang="sass">
.lists
    padding-left: 24px
    li
        padding: 6px 0px

h1, h2, h3
    font-weight: 700
h1
    font-size: 2em
    margin-bottom: .05em
h2
    font-size: 1.5em
    margin-bottom: .05em

h3
    font-size: 1.125em
    margin-bottom: .05em

</style>
